import React from 'react';
import Layout from '../../../components/layout';
import MetaData from '../../../components/meta-data';
import Headline from '../../../components/headline';
import Breadcrumbs from '../../../components/breadcrumbs';
var CarsIndex = function CarsIndex(props) {
    var _props$data$seo$edges, _props$data$seo$edges2, _props$data$seo$edges3, _props$data$m550$edge;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(MetaData, {
        title: "Car Photos",
        description: 'Car photos from Drew Templeton.  BMW M550 and more.',
        photos: {
            full: (_props$data$seo$edges = props.data.seo.edges[0].node.full) === null || _props$data$seo$edges === void 0 ? void 0 : _props$data$seo$edges.fixed,
            facebook: (_props$data$seo$edges2 = props.data.seo.edges[0].node.facebook) === null || _props$data$seo$edges2 === void 0 ? void 0 : _props$data$seo$edges2.fixed,
            twitter: (_props$data$seo$edges3 = props.data.seo.edges[0].node.twitter) === null || _props$data$seo$edges3 === void 0 ? void 0 : _props$data$seo$edges3.fixed
        }
    }), /*#__PURE__*/ React.createElement(Breadcrumbs, {
        path: props
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "copy"
    }, /*#__PURE__*/ React.createElement("h1", null, "Cars"), /*#__PURE__*/ React.createElement("p", null, "I grew up with love for cars. I remember helping my Dad restore his '73 Super Duty Trans Am and being lugged around to more car shows than I can count. I still love going to car shows and seeing everyone show off their pride and joys. I love just following cars in general and can really appreciate all types. Here's some shots of cars that I think are sweet."))), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'right',
        image: {
            source: (_props$data$m550$edge = props.data.m550.edges[Math.floor(Math.random() * props.data.m550.edges.length)].node.childImageSharp) === null || _props$data$m550$edge === void 0 ? void 0 : _props$data$m550$edge.fluid,
            altText: '2018 BMW M550'
        },
        link: '/photos/cars/m550/',
        copy: {
            headline: {
                h1: 'BMW M550'
            },
            text: '600 over 600.  First all wheel drive, M 5-series.  This thing rips.'
        }
    }));
};
export default CarsIndex;
var query = "625846560";
